import { useEffect, useRef } from 'react';
import { useToggle } from '@sdk/common/hooks/useToggle';

import { SCHEDULE_PATH_NAME } from '../onboardingChecklist.consts';

type Props = { isLoaded: boolean };

const usePublishScheduleModal = ({ isLoaded }: Props) => {
  const publishScheduleModalRef = useRef(null);
  const {
    isOn: triggerPublishModallOn,
    setOn: setTriggerPublishModallOn,
    setOff: setTriggerPublishModallOff,
  } = useToggle(false);

  useEffect(() => {
    //we need to display the modal on schedule tab after loading is finished, here we triggering the modal by triggerPublishModallOn and isLoadded flags
    if (triggerPublishModallOn && !isLoaded && window.location.pathname === SCHEDULE_PATH_NAME) {
      publishScheduleModalRef.current?.open();
      setTriggerPublishModallOff();
    }
  }, [isLoaded, triggerPublishModallOn, setTriggerPublishModallOff, publishScheduleModalRef]);

  return { setTriggerPublishModallOn, setTriggerPublishModallOff, publishScheduleModalRef };
};

export default usePublishScheduleModal;
